import routes from "operations/routing/routes";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ isAllowed, children, redirect = routes.dashboard }) => {
  if (!isAllowed) {
    return <Navigate to={redirect} replace />;
  }
  return children ? children : <Outlet />;
};

export default ProtectedRoute;
